import { _axios } from "@/plugins/axios";

const index = async (request) => {
    return await _axios.post(
      `/user/profile?page=${request.page}&resPerPage=${request.row}`, request
    );
};

const create = async request => await _axios.post(`/user/register`, request);

const update = async request =>
  await _axios.post(`/user/edit`, request, {
    headers: { "Content-Type": "multipart/form-data" }
  });

const destroy = async requestId => await _axios.post(`/user/remove`, requestId);

const indexChangePass = async (request = {}) => {
  if (request.search) {
    return await _axios.post(
      `/superadmin/help/forgotPassword?page=${request.page}&resPerPage=${request.row}`,
      { searchStr: request.search }
    );
  } else {
    return await _axios.post(
      `/superadmin/help/forgotPassword?page=${request.page}&resPerPage=${request.row}`,
      {}
    );
  }
};

const destroyAvatar = async request =>
  await _axios.post("/user/removePhoto", request);

const createForgotPass = async request =>
  await _axios.post("/user/forgot", request);

const logout = async () => await _axios.post("/user/logout", {});

const indexUsers = async request =>
  await _axios.post(
    `/user/simplifiedProfile?page=${request.page}&resPerPage=${request.row}`,
    {
      projectId: request.projectId
    }
  );

const indexAssigned = async request => {
  if (request.searchStr) {
    return await _axios.post(`/user/simplifiedProfile/assignedUser?page=${request.page}&resPerPage=${request.row}`, {
      projectId: request.projectId,
      searchStr: request.searchStr,
    });
  } else {
    return await _axios.post(`/user/simplifiedProfile/assignedUser?page=${request.page}&resPerPage=${request.row}`, {
      projectId: request.projectId
    });
  }
};

const indexReviewer = async request => {
  if (request.searchStr) {
    return await _axios.post(`/user/simplifiedProfile/reviewer?page=${request.page}&resPerPage=${request.row}`, {
      projectId: request.projectId,
      searchStr: request.searchStr
    });
  } else {
    return await _axios.post(`/user/simplifiedProfile/reviewer?page=${request.page}&resPerPage=${request.row}`, {
      projectId: request.projectId,
      assignedUserId: request.assignedUserId
    });
  }
};

const indexExcel = async (request) => _axios.post("/user/exportExcel", request, {
  headers: {
    "Content-Type": "application/json",
    Accept: "application/octet-stream"
  },
  responseType: "arraybuffer"
});
const getTemplate = async (request) => _axios.post("/user/template-import", request, {
  headers: {
    "Content-Type": "application/json",
    Accept: "application/octet-stream"
  },
  responseType: "arraybuffer"
});
// upload excel file
const uploadFile = async (request) => _axios.post("/user/import-user", request, {
  headers: {
    "Content-Type": "application/json",
    Accept: "application/octet-stream"
  },
  responseType: "arraybuffer"
});

const deleteBatch = async (request) => _axios.delete("/user/remove/batch", {data : request})

export {
  index,
  create,
  destroy,
  update,
  indexChangePass,
  destroyAvatar,
  createForgotPass,
  logout,
  indexUsers,
  indexAssigned,
  indexReviewer,
  indexExcel,
  deleteBatch,
  getTemplate,
  uploadFile
};
